module.exports = __webpack_public_path__ + "static/media/photography03.c16b75f7.png";